// /* boot.js */
import {bootstrap, container} from './include/services.js';

async function fetchTooltipContent(url) {
    try {
        const response = await fetch(url);
        if (!response.ok) throw new Error('Network response was not ok');
        const content = await response.text(); // or .json() if the response is JSON
        return content;
    } catch (error) {
        console.error('Error fetching tooltip content:', error);
        return 'Failed to load content'; // Fallback message
    }
}

/** @type {import('./include/services/DOMChangeObserver.js').DOMChangeObserver} */
const observer = container.resolve('observer');

observer.attachCallback(function(node) {
    let tooltipButtons = node.querySelectorAll('[data-tippy="url"][data-tippy-event][data-tippy-source][data-tippy-content]');

    tooltipButtons.forEach((button) => {
        const source = button.getAttribute('data-tippy-source');
        button.addEventListener('mouseenter', async () => {
            if (button.getAttribute('data-tippy-event') === 'hover') {
                const content = await fetchTooltipContent(url);
                button.setAttribute('data-tippy-content', content);
                let tippy = container.resolve('tippy');
                tippy(button, {
                    content: content,
                    allowHTML: true,
                    trigger: 'mouseenter',
                    // interactive: true,
                    theme: 'light',
                    // plugins: [followCursor, inlinePositioning], // Add plugins here
                    onShow(instance) {
                        // Update content every time the tooltip is shown
                        fetchTooltipContent(source).then(fetchedContent => {
                            instance.setContent(fetchedContent);
                        });
                    },
                }).show();
            }
        });

        button.addEventListener('click', async () => {
            if (button.getAttribute('data-tippy-event') === 'click') {
                const content = await fetchTooltipContent(source);
                button.setAttribute('data-tippy-content', content);
                let tippy = container.resolve('tippy');
                tippy(button, {
                    content: content,
                    allowHTML: true,
                    trigger: 'click',
                    interactive: true,
                    theme: 'light',
                    // plugins: [followCursor, inlinePositioning], // Add plugins here
                    onShow(instance) {
                        // Update content every time the tooltip is shown
                        fetchTooltipContent(source).then(fetchedContent => {
                            instance.setContent(fetchedContent);
                        });
                    },
                }).show();
            }
        });
    });

    tooltipButtons = node.querySelectorAll('[data-tippy="page"][data-tippy-event][data-tippy-source][data-tippy-content]');
    tooltipButtons.forEach((button) => {
        let content = button.getAttribute('data-tippy-content');

        /** @type {String} */
        const source = button.getAttribute('data-tippy-source');
        /** @type {HTMLElement} */
        const element = document.querySelector(source);
        if (element) {
            element.classList.add('d-none');
            content += element.innerHTML;
        }

        button.addEventListener('mouseenter', () => {
            if (button.getAttribute('data-tippy-event') === 'hover') {
                let tippy = container.resolve('tippy');
                tippy(button, {
                    content: content,
                    allowHTML: true,
                    trigger: 'mouseenter',
                    // interactive: true,
                    theme: 'light',
                    // plugins: [followCursor, inlinePositioning], // Add plugins here
                }).show();
            }
        });
        button.addEventListener('click', () => {
            if (button.getAttribute('data-tippy-event') === 'click') {
                let tippy = container.resolve('tippy');
                tippy(button, {
                    content: content,
                    allowHTML: true,
                    interactive: true,
                    trigger: 'click',
                    theme: 'light',
                    // plugins: [followCursor, inlinePositioning], // Add plugins here
                }).show();
            }
        });
    });
}, true);

window.bootstrap = bootstrap;
window.container = container;
